var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup163015(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19167 15.25C3.875 14.5167 4.91667 14.575 5.51667 15.375L6.35833 16.5C7.03333 17.3917 8.125 17.3917 8.8 16.5L9.64167 15.375C10.2417 14.575 11.2833 14.5167 11.9667 15.25C13.45 16.8333 14.6583 16.3083 14.6583 14.0917V4.7C14.6667 1.34167 13.8833 0.5 10.7333 0.5H4.43333C1.28333 0.5 0.5 1.34167 0.5 4.7V14.0833C0.5 16.3083 1.71667 16.825 3.19167 15.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.25 4.65625H10.9167",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.08325 8H10.0833",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163015);
export default __webpack_public_path__ + "static/media/Group 163015.a423b75285e9b1bb7995b650cfd3e214.svg";
export { ForwardRef as ReactComponent };